export class TextInput {

    constructor (private textContainer:JQuery) {
        textContainer.find('.form-text-clear').on("click",()=>this.clearEvent());
        textContainer.find('.form-text-info').on("click",()=>this.infoEvent());
    }

    public hasAutoSubmit() {
        var form=this.textContainer.closest("form");
        if (!form.length) return false;
        if (form.data("autosubmit")=="off") return false;
        if (form.hasClass("stepform")) return false;
        var select=this.textContainer.find("select");
        return select.data("autosubmit")!="off";
    }

    public submit() {
        var form=this.textContainer.closest("form");
        if (!form.find("[type=submit]:visible").length && this.hasAutoSubmit()) {
            var btn=form.find("[type=submit]");
            if (btn.length) btn.click(); else form.submit();
        }
        var input=this.textContainer.find("input");
        input.trigger("change","internal");
    }

    private infoEvent() {
        let description=this.textContainer.find("input").attr('aria-description');
        this.textContainer.find(".aria").toggleClass('visible');
    }

    private clearEvent() {
        let input=this.textContainer.find("input");
        if (input.is(':disabled')) return;
        input.val("").focus().trigger("input").trigger("clear");
        this.submit();
    }

}

export {};